<template>
  <div class="alert-container">
    <el-card class="main-card">
      <div slot="header" class="card-header">
        <div class="header-actions">
          <span class="card-title">告警信息</span>
          <div>
            <!-- <el-button type="warning" icon="el-icon-connection" @click="allClickWarring" class="refresh-btn">
              一键处理告警
            </el-button> -->
            <!-- <el-button type="primary" icon="el-icon-refresh" @click="refreshAlerts" class="refresh-btn">
              刷新
            </el-button> -->
          </div>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="filter-bar">
        设备名称：<el-input placeholder="请输入设备名称" v-model="searchKeyword" prefix-icon="el-icon-search" class="search-input"
          @input="handleSearch"></el-input>
        告警状态：
        <el-select v-model="alertStatus" placeholder="告警状态" clearable class="form-select" @input="handleSearch">
          <el-option label="全部" value=""></el-option>
          <el-option label="未处理" value="0"></el-option>
          <el-option label="已处理" value="1"></el-option>
        </el-select>
        <!-- <el-select v-model="alertLevel" placeholder="告警级别" clearable class="form-select">
          <el-option label="全部" value=""></el-option>
          <el-option label="紧急" value="critical"></el-option>
          <el-option label="重要" value="important"></el-option>
          <el-option label="一般" value="normal"></el-option>
        </el-select> -->
        <!-- <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" class="form-select"></el-date-picker> -->
        <!-- <el-button type="primary" @click="handleSearch" class="search-btn">
          搜索
        </el-button> -->
      </div>

      <!-- 告警表格 -->
      <el-table :data="pagedDevices" border class="device-table" stripe highlight-current-row
        :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="告警ID"></el-table-column>
        <!-- <el-table-column prop="sensorId" label="传感器ID"></el-table-column> -->
        <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
        <el-table-column prop="sensorName" label="传感器名称"></el-table-column>
        <el-table-column prop="sensorName" label="告警值">
          <template slot-scope="scope">
            <span>{{ scope.row.value }}{{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="告警内容"></el-table-column>

        <el-table-column prop="levelName" label="告警级别">
          <template slot-scope="scope">
            <el-tag type="danger">
              {{ scope.row.levelName }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="alarmDate" label="发生时间"></el-table-column>
        <el-table-column prop="confirm" label="状态">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.confirm)">
              {{ getStatusName(scope.row.confirm) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="text" @click="handleViewDetails(scope.row)" class="operation-btn view-btn">
              查看详情
            </el-button> -->
            <el-button size="mini" type="text" @click="handleProcessAlert(scope.row.sensorId)"
              v-if="scope.row.confirm == 0" class="operation-btn process-btn">
              处理
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" class="pagination"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { alarmList, confirmSensor,confirmAll } from '@/api/alerts'
export default {
  name: 'Alerts',
  data() {
    return {
      searchKeyword: '',
      alertStatus: '',
      alertLevel: '',
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      alerts: []
    }
  },
  computed: {
    filteredAlerts() {
      return this.alerts.filter(alert => {
        // 关键词筛选逻辑保持不变
        const matchesKeyword = !this.searchKeyword
          ? true
          : ((alert.equipmentName && alert.equipmentName.toLowerCase().includes(this.searchKeyword.toLowerCase())) ||
            (alert.name && alert.name.toLowerCase().includes(this.searchKeyword.toLowerCase())));
        return matchesKeyword;
      });
    },
    // 分页处理
    pagedDevices() {
      return this.filteredAlerts.map(alert => {
        return {
          id: alert.id, // 告警ID（与表格prop="id"匹配）
          equipmentName: alert.equipmentName, // 设备名称（与表格prop="equipmentName"匹配）
          sensorName: alert.sensorName, // 传感器名称（与表格prop="sensorName"匹配）
          value: alert.value, // 告警值（与表格{{ scope.row.value }}匹配，需确认接口字段名）
          unit: alert.unit, // 告警单位（与表格{{ scope.row.unit }}匹配，需确认接口字段名）
          name: alert.name, // 告警内容（与表格prop="name"匹配，需确认接口字段名）
          level: alert.levelName, // 接口返回的原始级别（如critical）
          levelName: alert.levelName, // 转换后的级别名称（如“紧急”）
          alarmDate: alert.alarmDate, // 发生时间（与表格prop="alarmDate"匹配）
          confirm: alert.confirm, // 状态（与表格prop="confirm"匹配）
          sensorId: alert.sensorId // 状态（与表格prop="confirm"匹配）
        };
      });
    }
  },

  mounted() {
    this.alarmInfo();
  },



  methods: {
    //告警列表接口
    async alarmInfo() {
      try {
        // 关键：传递分页参数给后端
        const params = {
          "sorted": [
            {

              "name": "id",
              "type": "DESC"
            }
          ],
          "filter": [
            {
              "name": "equipmentName",
              "value": this.searchKeyword,
              "type": "LIKE"
            },
            {
              "name": "confirm",
              "value": this.alertStatus,
              "type": "LIKE"
            }
          ],
          current: this.currentPage,
          size: this.pageSize,
          // 若有搜索/筛选条件，也一起传给后端（如搜索关键词、状态等）
          // status: this.alertStatus,
          // level: this.alertLevel
        };
        const res = await alarmList(params); // 传参给接口
        // console.log("后端返回的当前页数据：", res.result.records);
        // console.log("后端返回的总条数：", res.result.total);

        // 注意：后端分页时，前端无需再切片！直接将当前页数据赋值给pagedDevices的数据源
        this.alerts = res.result.records || []; // 此时alerts就是当前页的10条数据
        this.total = res.result.total; // 后端返回的真实总条数（支撑5056页）
      } catch (error) {
        console.error(error);
        this.alerts = [];
        this.total = 0;
      }
    },


    // 为表格行添加交替样式（与设备列表一致）
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    handleSearch() {
      this.pageSize = 10;
      this.currentPage = 1; // 改变每页条数时重置到第一页
      this.alarmInfo(); // 重新请求后端，获取搜索后的第一页数据
    },

    refreshAlerts() {
      this.$message.success('告警信息已刷新')
      this.currentPage = 1
      this.alarmInfo()
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变每页条数时重置到第一页
      this.alarmInfo(); // 重新请求后端，获取新条数下的第一页数据
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.alarmInfo();
    },

    getLevelName(level) {
      const levelMap = {
        critical: '紧急',
        important: '重要',
        normal: '一般'
      }
      return level || '未知'
    },

    getLevelTagType(level) {
      const typeMap = {
        critical: 'danger',
        important: 'warning',
        normal: 'info'
      }
      if (level == "紧急告警") {
        return typeMap.critical
      } else if (level == "重要告警") {
        return typeMap.warning
      }
    },

    getStatusName(status) {
      const statusMap = ["未处理", "已处理"]
      //  console.log("状态",statusMap)
      return statusMap[status] || '未知'
    },

    getStatusTagType(status) {
      const typeMap = ['danger', 'warning']

      return typeMap[status] || 'default'
    },

    handleViewDetails(alert) {
      this.$message.info(`查看告警 ${alert.id} 的详情`)
      // 实际项目中可添加跳转详情页逻辑
      // this.$router.push({ name: 'AlertDetail', query: { id: alert.id } })
    },

    //根据传感器处理告警
    handleProcessAlert(id) {
      // console.log("1111222id", id)
      this.$confirm('确定要处理该传感器告警吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await confirmSensor(id)
        if (res.code == "0000") {
          this.$message.success('告警处理成功')
          this.alarmInfo()
        }
      }).catch(() => {
        this.$message.info('已取消处理')
      })
    },

    //一键处理告警
    allClickWarring() {
      this.$confirm('确定要处理全部告警吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await confirmAll()
        if (res.code == "0000") {
          this.$message.success('告警处理成功')
          this.alarmInfo()
        }
      }).catch(() => {
        this.$message.info('已取消处理')
      })
    },

  }
}
</script>

<style scoped>
/* 全局容器样式（与设备列表容器一致） */
.alert-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* 主卡片样式（完全复用设备列表卡片样式） */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

/* 卡片头部样式 */
.card-header .header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

/* 刷新按钮样式（与添加设备按钮样式一致） */
.refresh-btn {
  transition: all 0.2s ease;
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域样式（与设备列表搜索区一致） */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 300px;
  height: 40px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 下拉框/日期选择器样式（复用设备列表表单选择器样式） */
.form-select {
  width: 180px;
  height: 40px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.form-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 搜索按钮样式（与添加按钮风格一致） */
.search-btn {
  transition: all 0.2s ease;
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 表格样式（完全复用设备列表表格样式） */
.device-table {
  margin: 0 20px;
  border-radius: 6px;
  overflow: hidden;
}

::v-deep .el-table th {
  background-color: #f7f8fa;
  font-weight: 500;
  color: #4b5563;
  padding: 12px 0;
}

::v-deep .el-table td {
  padding: 12px 0;
}

/* 表格行交替样式 */
.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

/* 表格行hover和当前行样式 */
::v-deep .el-table__row:hover>td {
  background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row>td {
  background-color: #e6f7ff !important;
}

/* 操作按钮样式（复用设备列表操作按钮逻辑） */
.operation-btn {
  padding: 4px 8px;
  margin: 0 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.view-btn {
  color: #1890ff;
}

.view-btn:hover {
  background-color: rgba(24, 144, 255, 0.1);
}

.process-btn {
  color: #52c41a;
  /* 处理按钮用成功色（与编辑按钮一致） */
}

.process-btn:hover {
  background-color: rgba(82, 196, 26, 0.1);
}

/* 分页样式（完全复用设备列表分页样式） */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

::v-deep .el-pagination {
  font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
  height: 32px;
  line-height: 32px;
  min-width: 32px;
  border-radius: 4px;
}

::v-deep .el-pagination .el-pager {
  margin-right: 12px;
  margin-left: 12px;
}

::v-deep .el-pagination .el-pager li {
  margin: 0 3px;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
  background-color: #1890ff;
  color: #fff;
}

/* 处理弹窗样式（与设备列表弹窗一致） */
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .custom-dialog .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
  background-color: #f7f8fa;
}

::v-deep .custom-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

::v-deep .custom-dialog .el-dialog__body {
  padding: 20px;
}

::v-deep .custom-dialog .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式适配（完全复用设备列表响应式逻辑） */
@media (max-width: 768px) {
  .alert-container {
    padding: 10px;
  }

  .search-input {
    width: 100%;
  }

  .form-select {
    width: 100%;
  }

  .header-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .pagination-container {
    text-align: center;
  }

  ::v-deep .el-table {
    font-size: 13px;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 8px 0;
  }

  .operation-btn {
    padding: 2px 6px;
    font-size: 12px;
  }
}
</style>
